/* ───────────────────────────────────────────────────────────────────────────
   DISCLOSURES THAT OPEN INSTEAD OF APPEARING.

   "these just snap and open and close need animation lol"

   <details> is the right element: it is a disclosure, the browser already
   knows what that means, it works before any script loads and with none at
   all, and a screen reader announces it correctly. What it does not do is
   animate, because the browser toggles the content between rendered and not
   rendered and there is no height to interpolate between those.

   CSS can nearly do it now, with interpolate-size and ::details-content and
   transition-behavior: allow-discrete. Nearly is the problem: that is a 2024
   Chrome feature, Firefox does not have it, and a product page is not the
   place to find out which of her customers is on what.

   So the toggle is intercepted and the height is animated by hand, which is
   the long-standing pattern for this:

     CLOSING  cancel the default, animate the whole <details> from its full
              height down to just its summary, and only then set open=false.
              Removing the content first is what makes it vanish.
     OPENING  set open=true immediately so the content is measurable, then
              animate up to summary + content from wherever it currently is.

   Starting from the CURRENT height rather than from zero is what lets a
   click land mid-animation without a jump: the running animation is
   cancelled and the new one starts where the old one had reached.

   The element keeps working if this file never loads. Without it the rows
   snap, which is exactly today.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var SEL = 'details.bpd__row, details[data-disclose]';

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* THE UNIT MATTERS AND IT IS NOT THE ONE YOU WROTE. --fy-disclose-ms is
     authored as 260ms and getComputedStyle hands it back as ".26s", because
     that is the computed form of a <time>. parseFloat then reads 0.26 and the
     animation runs for a quarter of a MILLISECOND, which looks exactly like
     the snap this file exists to remove. Found in the preview, not in the
     source, because the source says 260. */
  function asMs(value, fallback) {
    var v = String(value == null ? '' : value).trim();
    if (!v) return fallback;
    var n = parseFloat(v);
    if (isNaN(n)) return fallback;
    return /ms$/.test(v) ? n : n * 1000;
  }

  function timing() {
    var cs = window.getComputedStyle(document.documentElement);
    var ms = asMs(cs.getPropertyValue('--fy-disclose-ms'), 260);
    var ease = (cs.getPropertyValue('--fy-chrome-ease') || '').trim() || 'ease';
    return { duration: reduced() ? 0 : ms, easing: ease };
  }

  function enhance(el) {
    if (el.__bloomDisclose) return;
    el.__bloomDisclose = true;

    var summary = el.querySelector('summary');
    var body = el.querySelector('.bpd__body') || summary && summary.nextElementSibling;
    if (!summary || !body) return;

    var anim = null;
    var closing = false;

    function settle(open) {
      el.open = open;
      anim = null;
      closing = false;
      el.style.height = '';
      el.style.overflow = '';
    }

    function run(to, open) {
      var from = el.offsetHeight;
      el.style.overflow = 'hidden';
      if (anim) anim.cancel();
      var t = timing();
      if (!t.duration) {
        settle(open);
        return;
      }
      anim = el.animate({ height: [from + 'px', to + 'px'] }, t);
      anim.onfinish = function () {
        settle(open);
      };
      anim.oncancel = function () {
        closing = false;
      };
    }

    function shrink() {
      closing = true;
      run(summary.offsetHeight, false);
    }

    function grow() {
      /* Pin the height before open flips, or the content lands at full size
         for one frame and the animation starts from the answer. */
      el.style.height = el.offsetHeight + 'px';
      el.open = true;
      window.requestAnimationFrame(function () {
        run(summary.offsetHeight + body.offsetHeight, true);
      });
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (closing || !el.open) grow();
      else shrink();
    });
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) enhance(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  /* Shopify's section rendering replaces whole blocks, and the theme editor
     does it on every setting change, so new rows have to be picked up. */
  if ('MutationObserver' in window) {
    new window.MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
